module.exports = __webpack_public_path__ + "img/ABC-COVER.221a9946.png";